<div
    v-if="showBanner"
    class="sw-extension-store-statistics-promotion"
>
    <div class="sw-extension-store-statistics-promotion__app">
        <sw-extension-icon
            class="sw-extension-store-statistics-promotion__app-icon"
            :src="assetFilter('/swagextensionstore/administration/static/img/analytics/extension/icon.svg')"
        />

        <div class="sw-extension-store-statistics-promotion__app-info">
            <h4 class="sw-extension-store-statistics-promotion__app-info-name">
                {{ $t('sw-extension-store-statistics-promotion.app-name') }}
            </h4>

            <span class="sw-extension-store-statistics-promotion__app-info-description">
                {{ $t('sw-extension-store-statistics-promotion.app-description') }}
            </span>
        </div>
    </div>

    <mt-button
        class="sw-extension-store-statistics-promotion__go-to-app"
        variant="primary"
        :disabled="!linkToStatisticsAppExists"
        @click="goToStatisticsAppDetailPage"
    >
        {{ $t('sw-extension-store-statistics-promotion.go-to-app') }} <mt-icon name="regular-long-arrow-right" size="12px" />
    </mt-button>
</div>
